import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Table, Tag, Space } from "antd";
import translate from "../../../shared/utils/translations";

const CurrentPlanHistory = ({ isInvoice, setInvoice, data }) => {
  let navigate = useNavigate();

  const columns = [
    {
      title: translate("Invoice"),
      dataIndex: "payment_intent_id",
      key: "payment_intent_id",
      render: (item) => (
        <span className="table_bold_text w_icn ellipsis_That">
          <span className="icn">
            <FeatherIcon icon={"file"} />
          </span>{" "}
          {item}
        </span>
      ),
    },
    {
      title: translate("Billing Date"),
      dataIndex: "created_at",
      key: "created_at",
      render: (item) => (
        <>
          <div className="column_info">{translate("Billing Date")}</div>
          {item?.replace("T", " - ")?.split(".")[0]}
        </>
      ),
    },
    {
      title: translate("Amount"),
      dataIndex: "amount",
      key: "amount",
      render: (item, record) => (
        <>
          <div className="column_info">{translate("Amount")}</div>
          {item + " " + record.currency.toUpperCase()}
        </>
      ),
    },
    {
      title: translate("Plan"),
      dataIndex: "payment_type",
      key: "payment_type",
      render: (item) => (
        <>
          <div className="column_info">{translate("Plan")}</div>
          {item}
        </>
      ),
    },

    {
      title: translate("Status"),
      key: "status",
      dataIndex: "status",
      render: (status) => (
        <>
          <Tag
            key={status}
            className={`default__tag ${
              status === "fail" ? " unpaid" : " paid"
            }`}
          >
            {status?.capitalize()}
          </Tag>
        </>
      ),
    },
    {
      title: translate("Action"),
      key: "action",
      className: "table_actin",
      render: (text, record) => (
        <>
          <div className="column_info">{translate("Details")}</div>
          <a href={record?.invoice_url} target="_blank" className="table_d">
            {translate("Download")}
          </a>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="sessions__table">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            locale: {
              items_per_page: translate("Page"),
            },
            position: ["top", "bottom"],
          }}
          className="card_m"
        />
      </div>
    </>
  );
};

export default CurrentPlanHistory;
